module.exports = __webpack_public_path__ + "static/career-a-day-388488f8f2a29602c41eecc627edd30a.png";